import React from 'react'
import { FormattedMessage } from 'react-intl'
import FormattedCurrency from 'js/components/FormattedCurrency'

type Props = {
  discount: number
  discountOnlyFirstPurchase: boolean
  originalPrice: number
  currency: string
  price: number
  isFallbackPrice: boolean
  duration: number
  selected?: boolean
  durationText: React.ReactNode
}

const ChooseSubscriptionText = ({
  duration,
  discount,
  currency,
  price,
  durationText,
  isFallbackPrice,
  selected,
}: Props) => (
  <div>
    <div
      className={`lg:justify-left flex items-center capitalize transition-[padding] duration-300 ease-in-out type-17-bold lg:static lg:type-17-demibold ${
        selected ? 'pb-[5px]' : 'pb-0'
      }`}
    >
      {duration}&nbsp;
      {duration === 1 ? (
        <FormattedMessage id="Redeem.plans.month" defaultMessage="Month" />
      ) : (
        <FormattedMessage id="Redeem.plans.months" defaultMessage="Months" />
      )}
    </div>
    {discount > 0 && (
      <div className="font-demibold type-28-bold sm:type-36-bold lg:type-32-bold">
        <FormattedCurrency value={price} currency={currency} />
      </div>
    )}
    {isFallbackPrice && (
      <span className="hidden lg:block">
        <FormattedMessage
          id="chooseSubscription.regularPrice"
          defaultMessage="Regular price"
        />
      </span>
    )}
    <div
      className={`type-small flex leading-[1] text-TypeSub transition-[padding] duration-300 ease-in-out ${
        selected ? 'pt-[5px] text-black' : 'pt-0 text-beige-muted'
      }`}
    >
      {durationText}
    </div>
  </div>
)

export default ChooseSubscriptionText
